const hostMedia = 'eventsgo/media/'
// 座位列表 分页
export const FIND_SEAT_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/page' // /{pageSize}/{pageNumber}
// 嘉宾明细
export const FIND_GUEST_DETAIL_BY_ID = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/findById'
// 导出座位列表
export const EXPORT_SEAT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/export'
// 批量添加座位（实际只有单个添加）
export const BATCH_SAVE_SEAT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/batchCreate'
// 批量修改座位（实际只有单个修改）
export const BATCH_UPDATE_SEAT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/batchUpdate'
// 批量删除座位
export const BATCH_DELETE_SEAT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/batchDelete'
// 批量删除已作废座位
export const BATCH_DELETE_VOIDED_SEAT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/batchRelDelete'
// 新增嘉宾
export const CREATE_GUEST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/create'
// 修改嘉宾
export const UPDATE_GUEST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/update'
// 查询嘉宾
export const FIND_GUEST_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/page'
// 嘉宾取消参会
export const GUEST_CANCEL = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/cancel'
// 导出嘉宾报名
export const EXPORT_GUEST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/export'
// 查询嘉宾座位
export const FIND_GUEST_SEAT_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/page4Gest' // /{pageSize}/{pageNumber}
// 新增演讲嘉宾
export const CREATE_SPEAKER = 'eventsgo/media/services/eventsgo/enrollment/eventsgoactivityguest/create'
// 修改演讲嘉宾
export const UPDATE_SPEAKER = 'eventsgo/media/services/eventsgo/enrollment/eventsgoactivityguest/update'
// 批量删除演讲嘉宾
export const DELETE_SPEAKER = 'eventsgo/media/services/eventsgo/enrollment/eventsgoactivityguest/deleteList'
// 分页查询演讲嘉宾
export const GET_SPEAKER_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoactivityguest/page' // /{pageSize}/{pageNumber}
// 发送图片邮件
export const SEND_PICTURE_EMAIL = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/mail'

/** ================== 隐私配置 ================= */
// 隐私配置列表
export const FIND_PRIVACY_LIST = hostMedia + 'services/eventsgo/public/privacyCfg/findPrivacyList'
// 新增、修改隐私配置
export const ADD_UPDATE_PRIVACY = hostMedia + 'services/eventsgo/public/privacyCfg/addOrUpdatePrivacyInfo'
// 隐私配置详情
export const GET_PRIVACY_INFO = hostMedia + 'services/eventsgo/public/privacyCfg/findPrivacyCfgInfoById' // /{id}
// 批量删除隐私配置
export const DEL_PRIVACY_LIST = hostMedia + 'services/eventsgo/public/privacyCfg/delPrivacyList'
// 查询欧盟标识
export const GET_EU_FLAG = hostMedia + 'services/eventsgo/public/privacyCfg/findEUByIpAndUser/1'
// 审批配置
export const UPDATE_APPROVE_CONFIG = hostMedia + 'services/eventsgo/public/enrollment/eventsgoexh/update'
// 保存短信配置
export const SAVE_SMS_CONFIG = hostMedia + 'services/eventsgo/config/eventsgo/sms/save'
// 查询短信配置
export const QUERY_SMS_CONFIG = hostMedia + 'services/eventsgo/config/eventsgo/sms/query'
// 更新短信配置
export const UPDATE_SMS_CONFIG = hostMedia + 'services/eventsgo/config/eventsgo/sms/update'
// 审批人列表
export const GET_APPROVERS = 'eventsgo/common/services/eventsgo/common/permissions/findUsersByRoleIdAndDataScope'

/** ================== 转赠审批管理 ================= */
// 转赠审批管理分页列表
export const GET_SEAT_TRANS_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseattransfer/page'
// 批量通过审批
export const BATCH_PASS_SEAT_TRANS = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseattransfer/updateAgreeList'
// 批量驳回审批
export const BATCH_REJECT_SEAT_TRANS = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseattransfer/updateRejectList'

/** ================== 员工组别配置 ================= */
// 分页查询员工组别
export const GET_EMPGROUP_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/page' // /{pageSize}/{pageNumber}
// 查询全部员工组别
export const GET_EMPGROUP_ALL = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/all'
// 批量新增员工组别
export const BATCH_CREATE_EMPGROUP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/list/create'
// 批量修改员工组别
export const BATCH_UPDATE_EMPGROUP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/list/update'
// 批量修改员工组别
export const BATCH_DELETE_EMPGROUP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/list/delete'
// 导出员工组别
export const EXPORT_EMPGROUP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/export'
// 根据ID查询
export const GET_EMPGROUP_BYID = 'eventsgo/media/services/eventsgo/enrollment/eventsgoempgroup/findById'
/** ================== 员工报名管理 ================= */
// 分页查询员工报名
export const GET_EMP_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/page' // /{pageSize}/{pageNumber}
// 员工签到
export const EMP_SIGN = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/empSignin'
// 新增员工报名
export const CREATE_EMP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/create'
// 修改员工报名
export const UPDATE_EMP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/update'
// 批量取消员工报名
export const BATCH_CANCEL_EMP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/list/delete'
// 批量删除员工报名
export const BATCH_DELETE_EMP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/batch-delete'
// 转让工作证
export const TRANS_WORK_CARD = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/transfer'
// 座位号恢复
export const SEAT_RECOVER = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/recover'
// 导出员工报名
export const EXPORT_EMP = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/export'
// 上传员工头像
export const UPLOAD_EMP_HEADER = 'eventsgo/media/services/eventsgo/attachment/file/uploademp?ulType=eventsgoAttachment&compressPress=1'

/** ================== 议程配置 ================= */
// 分页查询议程配置
export const GET_ACTIVITY_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoActivity/findByPage' // /{pageSize}/{pageNumber}
// 批量添加议程配置
export const BATCH_ADD_ACTIVITY = 'eventsgo/media/services/eventsgo/enrollment/eventsgoActivity/createEventsgoActivityList'
// 批量修改议程配置
export const BATCH_UPDATE_ACTIVITY = 'eventsgo/media/services/eventsgo/enrollment/eventsgoActivity/updateEventsgoActivityList'
// 批量删除议程配置
export const BATCH_DELETE_ACTIVITY = 'eventsgo/media/services/eventsgo/enrollment/eventsgoActivity/deleteEventsgoActivityList'

// 导入员工组别、员工报名
export const IMPORT_EXCEL = 'eventsgo/media/servlet/upload?ulType=EventsgoExcelImport&modelType=media'
// 导入任务查询
export const FIND_IMPORT_EXCEL_BY_TASKID = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/findByTaskId'
// 设置员工权限
export const EMP_PERM_SETTING = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/setEmpPermission'
// 发送员工参会消息
export const SEND_EMP_ATTEND_MSG = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/sendEmpAttendMessage'
// 发送参会消息
export const SEND_GUEST_ATTEND_MSG = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/sendAttendMessage'
// 查询发送日志
export const FIND_MESSAGE_LOG_BY_PAGE = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/findMessageLogByPage'
// 待办列表
export const EMP_TASK_LIST = 'eventsgo/media/services/eventsgo/enrollment/empWorkFlow/myEmpTask'
// 批量审批
export const BATCH_APPROVE_EMP = 'eventsgo/media/services/eventsgo/enrollment/empWorkFlow/batchApprove'
// 复核审批
export const BATCH_REVIEW_APPROVE = 'eventsgo/media/services/eventsgo/enrollment/empWorkFlow/batchReviewApprove'
// 审批详情
export const APPROVE_DETAIL = 'eventsgo/media/services/eventsgo/enrollment/empWorkFlow/empTaskDetail'
// 审批日志
export const REVIEW_TASK_LIST = 'eventsgo/media/services/eventsgo/enrollment/empWorkFlow/reviewTaskList'
// 员工权限配置列表
export const GET_EMPPERM_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemppermissionvo/page'
// 员工权限配置 批量新增、修改、删除
export const BATCH_EMP_PERM = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemppermissionvo/list'
// 区域列表
export const GET_REGION_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoresourceregionvo/page'
// 批量操作区域 新增、修改、删除
export const BATCH_HANDLE_REGION = 'eventsgo/media/services/eventsgo/enrollment/eventsgoresourceregionvo/list'
// 票众列表
export const GET_CLASS_LIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoaudienceclassvo/page'
// 批量操作票众 新增、修改、删除
export const BATCH_HANDLE_CLASS = 'eventsgo/media/services/eventsgo/enrollment/eventsgoaudienceclassvo/list'
// 导出票众分类
export const EXPORT_AUDIENCE_CLASS = 'eventsgo/media/services/eventsgo/enrollment/eventsgoaudienceclassvo/export'
// 导出区域
export const EXPORT_REGION = 'eventsgo/media/services/eventsgo/enrollment/eventsgoresourceregionvo/export'
// 导出员工权限
export const EXPORT_PERMISSION = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemppermissionvo/export'
// 注册管理统计
export const REGIST_STATISTICS = 'eventsgo/media/services/eventsgo/enrollment/eventsgoregistration/count'
// 是否显示电子票
export const SHOW_TICKET = 'eventsgo/media/services/eventsgo/enrollment/eventsgoseatnumber/showTicket'
// 批量下载员工图片
export const BATCH_DOWNLOAD_EMPIMG = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/exportEmpImg'
// 嘉宾统计
export const GUEST_STATIC_AUDIENCE_COUNT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/staticGuestAudienceCount'
// 嘉宾统计导出
export const GUEST_STATIC_EXPORT_COUNT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoguest/exportStaticGuestCount'
/** ================== 黑名单 ================= */
// 分页查询议程配置
export const GET_BLACKLIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoGuestBlacklist/page'
// 单个查询根据id
export const GET_BLACKLIST_BY_ID = 'eventsgo/media/services/eventsgo/enrollment/eventsgoGuestBlacklist/findByBlacklistId'
// 创建黑名单
export const CREATE_BLACKLIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoGuestBlacklist/create'
// 更新黑名单
export const UPDATE_BLACKLIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoGuestBlacklist/update'
// 删除黑名单
export const DELETE_BLACKLIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoGuestBlacklist/delete'
// 导出黑名单
export const EXPORT_BLACKLIST = 'eventsgo/media/services/eventsgo/enrollment/eventsgoGuestBlacklist/export'
// 黑名单注册列表
export const GET_BLACKLIST_REGISTER = 'eventsgo/media/services/eventsgo/enrollment/eventsgoBlacklistRecord/page'
// 导出黑名单注册
export const EXPORT_BLACKLIST_REGISTER = 'eventsgo/media/services/eventsgo/enrollment/eventsgoBlacklistRecord/export'
// 审批签到统计
export const SIGN_APPROVED_STATISTIC = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/statisticByGroup'
// 审批签到统计导出
export const SIGN_APPROVED_STATISTIC_EXPORT = 'eventsgo/media/services/eventsgo/enrollment/eventsgoemp/exportStatistic'
